export default "__VITE_ASSET__C2nTIJB8__"